import { React} from "react"
import Grid from "@material-ui/core/Grid"

import { ListView, ListViewHeader } from "@progress/kendo-react-listview"
import { Button } from "@progress/kendo-react-buttons"
import { Input } from "@progress/kendo-react-inputs"


export default function NwecHolbaRegistrationForm(props) {

  const {modalHandler, newUserSubmit, newUserDetails, defaultGroup} = props

  const UserHeader = () => {
    return (
      <ListViewHeader
        style={{
          color: "rgb(160, 160, 160)",
          fontSize: 16,
        }}
        className="pl-3 pb-2 pt-2"
      >
        Officers
      </ListViewHeader>
    )
  }

  const UserRender = (props) => {
    let item = props.dataItem
    return (
      <Grid
        container
        direction="column"
        className="k-listview-item row p-2 border-bottom align-middle"
        style={{
          margin: 0,
          display: "flex",
          width: "18vw",
        }}
      >
        <Grid item>
          <h2
            style={{
              fontSize: 14,
              color: "#454545",
              marginBottom: 0,
            }}
            className="text-uppercase"
          >
            {item.details.name}
          </h2>
        </Grid>
        <Grid container item direction="row">
          <Grid item>
            <p
              style={{
                fontSize: 12,
                color: "#a0a0a0",
              }}
            >
              {item.details.email}
            </p>
          </Grid>
          <Grid container justifyContent="flex-end" item>
            <Button icon="cog" themeColor={"secondary"}
              rounded={"full"} 
              onClick={e=> modalHandler(e,item)}
              style={{ width: "2rem", height: "2rem", color:"white" }}/>
          </Grid>
        </Grid>
      </Grid>
    )
  }

  return (
    <>
      <Grid container direction="column" alignItems="flex-start">
        <Grid item >
          <h5>New Officer</h5>

          <Grid container item direction="column">
            <Input
              label="Name"
              id="name"
              style={{ width: "30vw" }}
              onChange={(e) => newUserDetails(e)}
            />
            <Grid container item direction="row">
              <Input
                label="Email"
                id="email"
                style={{ width: "30vw" }}
                onChange={(e) => newUserDetails(e)}
              />
              <Button
                icon="plus"
                themeColor={"secondary"}
                rounded={"full"}
                style={{
                  marginTop: "1.3rem",
                  marginLeft: "0.5rem",
                  width: "2rem",
                  height: "2rem",
                  color: "white",
                }}
                onClick={e =>newUserSubmit(e, defaultGroup)}
              />
            </Grid>   
          </Grid>
        </Grid>
        <Grid container direction="row" item style={{ marginTop: "1rem" }}>
          <Grid item>
            <div>
              <ListView
                data={props.adminList}
                item={UserRender}
                header={UserHeader}
              />
            </div>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}
